import { useState, useEffect } from "react";

/**
 * Returns true if the user is authenticated with Sleeper connected.
 * Used by content components to hide their internal navbar when
 * the app's main Navbar is already rendered.
 */
export function useIsAppNavVisible() {
  const [isAuth, setIsAuth] = useState(false);
  useEffect(() => {
    try {
      const saved = localStorage.getItem("dynastydeal_user");
      if (saved) {
        const parsed = JSON.parse(saved);
        if (parsed.sleeper_username) setIsAuth(true);
      }
    } catch {}
  }, []);
  return isAuth;
}
